<template>
    <div>
        <div class="flex flex-row items-center w-full">
            <div class="flex flex-row items-center">
				<span class="bg-blue-500 p-3 rounded-md">
					<span :class="iconWizard">
					</span>
				</span>
                <div class="pl-3 flex flex-col items-begin">
                    <span class="text-base font-normal text-gray-900">Wizard Completion Status</span>
                    <div class="flex items-row justify start">
                        <span class="text-2xl font-semibold text-blue-600 mr-2">{{ completionPercent }}%</span>
                        <div
                            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800 md:mt-2 lg:mt-0">
                            Next: {{ nextStep }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {iconNamesMixin} from "@/mixins/IconNamesMixin";

export default {
    name: "AlarmStatus",
    mixins: [iconNamesMixin],
    props: {
        company: String,
        status: Object,
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {},
    computed: {
        completionPercent() {
            return this.status.completionPercent
        },
        nextStep() {
            return this.status.nextStep
        },
    },
    beforeUnmount() {
    },
}

</script>


